<template>
  <div class="app flex-row align-items-center bg-login">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card no-body class="p-4">
            <b-card-body>
              <b-row>
                <b-col cols="12" class="text-center">
                  <h1 class="title-login">Autenticação</h1>
                  <p class="text-muted subtitle-login">&nbsp;</p>
                </b-col>
              </b-row>
              <b-row class="justify-content-center">
                <b-col xl="5" v-if="!!qrCode">
                  <b-card no-body class="p-4">
                    <b-card-body class="inner-card-body">
                      <p class="text-muted subtitle-login">
                        QR Code
                        {{ environment == "bird" ? "Bird ID" : "Vault ID" }}
                      </p>
                      <p class="text-muted">
                        Abra o app Bird ID no seu dispositivo e toque em
                        <strong>Autenticar</strong>.
                      </p>
                      <div class="qr-code">
                        <qrcode-vue
                          :value="qrCode"
                          :size="200"
                          level="H"
                          class="text-center"
                        />
                        <div class="qr-code-text">
                          <b-input-group class="mb-3 mt-2">
                            <b-form-input
                              type="text"
                              v-model="qrCode"
                              class="form-control"
                              readonly
                            />
                            <b-input-group-append>
                              <b-button
                                variant="secondary"
                                @click="copyToClipboard"
                              >
                                <i class="fa fa-copy"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </div>
                        <div class="text-right">
                          <span class="text-muted" v-if="environment == 'bird'">
                            <a
                              href="#"
                              @click.prevent="changeEnvironment('vault')"
                              >Alterar para Vault ID</a
                            ></span
                          >
                          <span
                            class="text-muted"
                            v-if="environment == 'vault'"
                          >
                            <a
                              href="#"
                              @click.prevent="changeEnvironment('bird')"
                              >Alterar para Bird ID</a
                            ></span
                          >
                        </div>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col xl="7">
                  <b-card no-body class="p-4">
                    <b-card-body class="inner-card-body">
                      <p class="text-muted subtitle-login">OTP</p>
                      <p class="text-muted">
                        Digite o código OTP exibido no seu app Bird ID para
                        concluir a autenticação.
                      </p>
                      <b-form @submit.stop.prevent>
                        <b-input-group class="mb-3">
                          <b-input-group-prepend
                            ><b-input-group-text
                              ><i class="icon-user"></i></b-input-group-text
                          ></b-input-group-prepend>
                          <b-form-input
                            type="text"
                            v-model="loginData.username"
                            class="form-control"
                            placeholder="Ex.: 01234567899"
                            autocomplete="username"
                          />
                        </b-input-group>
                        <b-input-group class="mb-4">
                          <b-input-group-prepend
                            ><b-input-group-text
                              ><i class="icon-lock"></i></b-input-group-text
                          ></b-input-group-prepend>
                          <b-form-input
                            type="password"
                            v-model="loginData.password"
                            class="form-control"
                            placeholder="OTP"
                          />
                        </b-input-group>
                        <b-row>
                          <b-col cols="12">
                            <b-button
                              type="submit"
                              @click="authenticate"
                              :disabled="
                                !loginData.password || !loginData.username
                              "
                              variant="primary"
                              class="px-4 form-control"
                              >Autenticar</b-button
                            >
                          </b-col>
                          <!-- <b-col cols="6" class="text-right">
                            <b-button variant="link" class="px-0">Esqueceu a senha?</b-button>
                          </b-col> -->
                        </b-row>
                      </b-form>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <img src="../../assets/logo.svg" alt="" style="width: 150px" />
      </b-row>
    </div>
    <b-modal
      id="modal-select-corporation"
      ref="modal"
      @show="resetCorporationModal"
      @hidden="resetCorporationModal"
      hide-footer
      hide-header
    >
      <h2>Corporações disponíveis</h2>
      <p class="text-muted">Selecione a corporação desejada</p>
      <div class="input-group input-group-sm search-area">
        <input
          class="form-control"
          id="txt-search"
          type="text"
          name="txt-search"
          v-model="searchValue"
        />
        <span class="input-group-append">
          <button
            id="btn-search"
            class="btn btn-secondary"
            type="button"
            disabled
          >
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
      <br />
      <b-list-group>
        <b-list-group-item
          button
          v-for="(itm, idx) in filteredCorporations"
          v-bind:key="itm.id"
          @click="handleSelectCorporation(idx)"
          >{{ itm.name }}</b-list-group-item
        >
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import { requestError, env } from "@/shared/utils";
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import QrcodeVue from "qrcode.vue";

export default {
  name: "Login",
  components: {
    Loading,
    QrcodeVue,
  },
  data() {
    return {
      loginData: {
        username: "",
        password: "",
        grant_type: "password",
        scope: "application_ext",
        lifetime: 259200,
      },
      qrCode: null,
      environment: "bird",
      pingInterval: null,
      sending: false,
      corporations: [],
      corporation: {
        id: "",
        cnpj: "",
        name: "",
      },
      searchValue: "",
    };
  },
  computed: {
    filteredCorporations: function () {
      if (this.searchValue) {
        var regex = new RegExp(this.searchValue, "ig");
        return this.corporations.filter(
          (itm) => itm.name.match(regex) || itm.cnpj.match(regex)
        );
      }
      return this.corporations;
    },
  },
  async mounted() {
    this.environment = localStorage.environment || "bird";
    this.startAuth();
  },
  methods: {
    ...mapActions(["setCorporationSelected", "setCorporationList"]),

    changeEnvironment(environment) {
      this.environment = environment;
      localStorage.environment = this.environment;
      this.startAuth();
    },

    async startAuth() {
      const loader = this.$loading.show();
      try {
        clearInterval(this.pingInterval);
        let response = await axios.post(`${env.urlBillingApi}/auth-start`, {
          grant_type: "password",
          scope: "application_ext",
          lifetime: 259200,
          environment: this.environment,
        });
        this.qrCode = response.data.qr_code;
        this.shortToken = response.data.short_token;
        this.startPing();
      } catch (error) {
        this.$toasted.error(error.response.data.detail.message, {
          theme: "bubble",
          position: "top-right",
          duration: 5000,
        });
      } finally {
        loader.hide();
      }
    },

    async startPing() {
      clearInterval(this.pingInterval);
      this.pingInterval = setInterval(async () => {
        try {
          let response = await axios.get(
            `${env.urlBillingApi}/auth-start/${this.shortToken}`
          );
          if (response.data.auth_completed) {
            clearInterval(this.pingInterval);
            this.loginData.username = response.data.username;
            this.completeAuth(response);
          }
        } catch (error) {
          clearInterval(this.pingInterval);
          console.log(error);
        }
      }, 2000);
    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.qrCode);
      this.$toasted.success("Copiado para área de transferência!", {
        theme: "bubble",
        position: "top-right",
        duration: 5000,
      });
    },

    completeAuth(response) {
      localStorage.access_token = response.data.access_token;
      localStorage.username = this.loginData.username;
      localStorage.client_id = this.loginData.client_id;
      let roles = response.data.roles || [];
      this.setCorporationList(response.data.corporations);
      let hasCorporation =
        response.data.corporations && response.data.corporations.length > 0;
      if (!hasCorporation) {
        localStorage.corporation = null;
        this.$router.replace({ path: "/" });
      } else if (response.data.corporations.length == 1) {
        this.setCorporationSelected(response.data.corporations[0]);
        this.$router.replace({ path: "/" });
      } else {
        this.corporations = response.data.corporations;
        this.$refs.modal.show();
      }
      if (hasCorporation) {
        roles.push("has_corporation");
      }
      localStorage.roles = JSON.stringify(roles);
    },

    authenticate() {
      var _this = this;
      this.sending = true;
      const loader = _this.$loading.show();
      axios
        .post(`${env.urlBillingApi}/auth`, this.loginData)
        .then((response) => {
          _this.completeAuth(response);
          loader.hide();
        })
        .catch((error) => {
          _this.$toasted.error(error.response.data.detail.message, {
            theme: "bubble",
            position: "top-right",
            duration: 5000,
          });
          // requestError(error);
          loader.hide();
        })
        .finally(() => {
          _this.sending = false;
          loader.hide();
        });
    },
    resetCorporationModal() {
      this.corporation = {
        id: "",
        cnpj: "",
        name: "",
      };
    },
    handleSelectCorporation(idx) {
      var _this = this;
      const loader = _this.$loading.show();
      axios
        .put(`${env.urlBillingApi}/auth`, [
          { corporationId: this.filteredCorporations[idx].id },
        ])
        .then((response) => {
          _this.setCorporationSelected(_this.filteredCorporations[idx]);
          _this.$nextTick(() => {
            _this.$refs.modal.hide();
            loader.hide();
            _this.$router.replace({ path: "/" });
          });
        })
        .catch((error) => {
          requestError(error);
          loader.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c8ced3;
  border-radius: 14px;
  -webkit-box-shadow: 0px 6px 15px -1px rgba(0, 0, 0, 0.41);
  -moz-box-shadow: 0px 6px 15px -1px rgba(0, 0, 0, 0.41);
  box-shadow: 0px 6px 15px -1px rgba(0, 0, 0, 0.41);
}
.bg-login {
  background-image: url("../../assets/bg-login.jpg");
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #d7e5e6;
}
.title-login {
  font-family: Montserrat-Light;
  color: #210f3a;
}
.subtitle-login {
  font-family: Montserrat-Bold;
  color: #210f3a !important;
}
.form-control {
  border: 1px solid #210f3a;
}
.input-group-text {
  background-color: #bab9c3;
  border: 1px solid #210f3a;
}
.btn {
  font-family: Montserrat-Light;
}
.inner-card-body {
  padding: 0;
}
/* Media query para dispositivos móveis */
@media (max-width: 768px) {
  .qr-code-text {
    display: block; /* Exibe o texto em dispositivos móveis */
  }
}
@media (min-width: 769px) {
  .qr-code-text {
    display: none; /* Oculta o texto em dispositivos maiores */
  }
}
</style>
